import * as React from 'react';

type IconSegmentoOnlineStoreProps = React.SVGProps<SVGSVGElement>;

export const IconSegmentoOnlineStore: React.FC<IconSegmentoOnlineStoreProps> = (props) => (
	<svg
		width={25}
		height={24}
		viewBox="0 0 25 24"
		fill="#BBC2C7"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<g clipPath="url(#clip0_1646_23726)">
			<path d="M16.8333 12C16.8333 13.0406 16.777 14.0437 16.6786 15H7.98794C7.88481 14.0437 7.83325 13.0406 7.83325 12C7.83325 10.9594 7.8895 9.95625 7.98794 9H16.6786C16.7817 9.95625 16.8333 10.9594 16.8333 12ZM18.1833 9H23.9536C24.202 9.96094 24.3333 10.9641 24.3333 12C24.3333 13.0359 24.202 14.0391 23.9536 15H18.1833C18.2817 14.0344 18.3333 13.0312 18.3333 12C18.3333 10.9688 18.2817 9.96562 18.1833 9ZM23.4614 7.5H17.9911C17.5223 4.50469 16.5942 1.99688 15.3989 0.39375C19.0692 1.36406 22.0551 4.02656 23.4567 7.5H23.4614ZM16.4723 7.5H8.19419C8.48013 5.79375 8.92075 4.28438 9.45981 3.06094C9.952 1.95469 10.5004 1.15313 11.0301 0.646875C11.5551 0.15 11.9911 0 12.3333 0C12.6754 0 13.1114 0.15 13.6364 0.646875C14.1661 1.15313 14.7145 1.95469 15.2067 3.06094C15.7504 4.27969 16.1864 5.78906 16.4723 7.5ZM6.67544 7.5H1.20513C2.61138 4.02656 5.59263 1.36406 9.26763 0.39375C8.07231 1.99688 7.14419 4.50469 6.67544 7.5ZM0.712939 9H6.48325C6.38481 9.96562 6.33325 10.9688 6.33325 12C6.33325 13.0312 6.38481 14.0344 6.48325 15H0.712939C0.464502 14.0391 0.333252 13.0359 0.333252 12C0.333252 10.9641 0.464502 9.96094 0.712939 9ZM9.45981 20.9344C8.91606 19.7156 8.48013 18.2062 8.19419 16.5H16.4723C16.1864 18.2062 15.7458 19.7156 15.2067 20.9344C14.7145 22.0406 14.1661 22.8422 13.6364 23.3484C13.1114 23.85 12.6754 24 12.3333 24C11.9911 24 11.5551 23.85 11.0301 23.3531C10.5004 22.8469 9.952 22.0453 9.45981 20.9391V20.9344ZM6.67544 16.5C7.14419 19.4953 8.07231 22.0031 9.26763 23.6063C5.59263 22.6359 2.61138 19.9734 1.20513 16.5H6.67544ZM23.4614 16.5C22.0551 19.9734 19.0739 22.6359 15.4036 23.6063C16.5989 22.0031 17.5223 19.4953 17.9958 16.5H23.4614Z" />
		</g>
		<defs>
			<clipPath id="clip0_1646_23726">
				<rect
					width="24"
					height="24"
					fill="white"
					transform="translate(0.333252)"
				/>
			</clipPath>
		</defs>
	</svg>
);
